import { Component, h, Prop } from '@stencil/core';
import GoBackIcon from '../svg-elements/go-back-icon';


@Component({
    tag: 'rentware-header',
    shadow: false,
    styleUrl: 'style.sass',
})
export class RentwareHeader {
    @Prop() onButtonClick;
    @Prop() headerTitle: string;

    render() {
        return (
            <div class="HeaderContainer">
                <span class="HeaderTitle">
                    {this.headerTitle}
                </span>

                <div
                    class="GlobalButtonSVG"
                    onClick={this.onButtonClick}
                    tabindex="0"
                >
                    <GoBackIcon />
                </div>
            </div>
        )
    }
}
